var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #3e3f41;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1753",
    "data-name": "\\u7EC4 1753",
    transform: "translate(-164 -1483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_419",
    "data-name": "\\u77E9\\u5F62 419",
    className: "cls-1",
    width: 48,
    height: 48,
    transform: "translate(164 1483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_13",
    "data-name": "\\u8DEF\\u5F84 13",
    className: "cls-2",
    d: "M163.851,130.3a19.75,19.75,0,0,0-7.542-14.2l-.266-.184,0,0a1.594,1.594,0,0,0-.833-.236c-1.014,0-1.618.489-1.618,1.307a1.593,1.593,0,0,0,.59,1.229l0,.007.235.168c3.707,2.65,5.794,6.67,6.2,11.949l0,.058c0,.044-.006.089-.006.134a1.615,1.615,0,0,0,3.228.089h.032Zm-5.2-27.055a14.741,14.741,0,0,0-29.48,0,14.413,14.413,0,0,0,5.267,11.146,19.863,19.863,0,0,0-10.468,16.108l-.019.282c0,.006,0,.012,0,.018l0,.026h0c0,.014,0,.027,0,.041a1.37,1.37,0,1,0,2.739,0c0-.014,0-.028,0-.041h.028l.021-.281a16.866,16.866,0,0,1,10.4-14.381,17.441,17.441,0,0,0,6.776,1.649,14.75,14.75,0,0,0,6.389-1.456l1.494-.867,1.22-.8A14.43,14.43,0,0,0,158.648,103.242Zm-14.74,11.633a11.634,11.634,0,1,1,11.779-11.634A11.72,11.72,0,0,1,143.909,114.875Z",
    transform: "translate(44.054 1396.523)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.542b5236af783dfdcac0a8f40a54c4d3.svg";
export { ForwardRef as ReactComponent };